module.exports = __webpack_public_path__ + "88b276605fe41fbcff9f2227399dce8f.fbx";